import { ENDPOINT } from "../configs/api";
import { ClassContent, VocabRecordType, VocabResult } from "../types/session";
import { RequestResponse } from "../types/httpClient";
import { httpClient } from "./httpClient";

export async function getStudentClassContent(): Promise<ClassContent | null> {
    const response: RequestResponse = await httpClient.get(ENDPOINT.iclass.studentClassContent)
    if (response.data.code > 0) {
        return null
    }
    return response.data.results
}
export async function getTeacherClassContent(classId: number): Promise<ClassContent | null> {
    const response: RequestResponse = await httpClient.get(`${ENDPOINT.iclass.teacherClassContent}/${classId}`)
    if (response.data.code > 0) {
        return null
    }
    return response.data.results
}

//Vocab services
export async function submitAudioVocab(sentence: string, audio_file: Blob, audio_length: number, type: VocabRecordType, vocab_id: number): Promise<VocabResult | null> {
    const response: RequestResponse = await httpClient.post(ENDPOINT.iclass.submitAudioVocab, { sentence, audio_file, audio_length, type, vocab_id }, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    if (response.data.code > 0) {
        return null
    }

    if (!response.data.results?.utterance?.length) {
        return null
    }

    return response.data.results.utterance[0]
}